import { render, staticRenderFns } from "./CashierJournal.vue?vue&type=template&id=a494c8d0&scoped=true"
import script from "./CashierJournal.vue?vue&type=script&lang=js"
export * from "./CashierJournal.vue?vue&type=script&lang=js"
import style0 from "./CashierJournal.vue?vue&type=style&index=0&id=a494c8d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a494c8d0",
  null
  
)

export default component.exports